import { ability } from '@/ability';
import { ActiveTenantService } from '@/services/ActiveTenantService';

// "All tenants" widens the data scope, so privilege checks widen with it: under a specific
// tenant the check is scoped to that tenant; under "All tenants" holding the privilege in any
// of the user's tenants qualifies. Lives outside ActiveTenantService so that service stays
// import-free for axiosInstance.
export function canInAnyTenant(action: string): boolean {
  const active = ActiveTenantService.activeTenant.value;
  if (active) {
    return ability.can(action, active);
  }
  return ActiveTenantService.tenantOptions.value.some((tenant) => ability.can(action, tenant));
}
